define(['backbone', 'models/Scale'], function(Backbone, ScaleModel) {
  return Backbone.Collection.extend({
    model: ScaleModel
  });
});
